import type { TranslationStrings } from "../types";

export const es: TranslationStrings = {
  "All set!": "\u00a1Todo listo!",
  "Your World ID is now connected": "Tu World ID ahora est\u00e1 conectado",
  "Already verified": "Ya verificado",
  "You've already verified for this action.":
    "Ya has verificado para esta accion.",
  "Something went wrong": "Algo sali\u00f3 mal",
  "Request cancelled": "Solicitud cancelada",
  "You've cancelled the request in World App.":
    "Has cancelado la solicitud en World App.",
  "Verification unavailable": "Verificacion no disponible",
  "This verification request couldn't be completed. Please contact the website owner.":
    "No se pudo completar esta solicitud de verificacion. Por favor contacta al propietario del sitio web.",
  "Connection lost": "Conexion perdida",
  "Please check your connection and try again.":
    "Por favor verifica tu conexion e intenta de nuevo.",
  "Verification declined": "Verificaci\u00f3n rechazada",
  "Failed to verify your credential proof. Please contact the website owner.":
    "No se pudo verificar tu prueba de credencial. Por favor contacta al propietario del sitio web.",
  "We couldn't complete your request. Please try again.":
    "No pudimos completar tu solicitud. Por favor intenta de nuevo.",
  "Try Again": "Intentar de nuevo",
  Close: "Cerrar",
  "Open World App": "Abrir World App",
  "QR Code copied": "C\u00f3digo QR copiado",
  "Connect your World ID": "Conecta tu World ID",
  "Use phone camera to scan the QR code":
    "Usa la c\u00e1mara del tel\u00e9fono para escanear el c\u00f3digo QR",
  "Connecting...": "Conectando...",
  "Please continue in app": "Por favor contin\u00faa en la aplicaci\u00f3n",
  "Transmitting verification to host app. Please wait...":
    "Enviando verificaci\u00f3n a la aplicaci\u00f3n anfitriona. Por favor espera...",
  "You will be redirected to the app, please return to this page once you're done":
    "Ser\u00e1s redirigido a la aplicaci\u00f3n, por favor regresa a esta p\u00e1gina una vez que hayas terminado",
  "Terms & Privacy": "T\u00e9rminos y privacidad",
};
